<template>
  <keep-alive>
    <div class="d-flex">
      <component
        :is="component"
        :value="value"
        :label="label"
        :path="path"
        :item-text="itemText"
        :sort-by="sortBy"
        :item-value="itemValue"
        :api-get-response-item-text="apiGetResponseItemText"
        :mandatory-filters="mandatoryFilters"
        :get-data="responseData"
        :rules="rules"
        :vid="vid"
        :return-object="returnObject"
        :readonly="readonly"
        :clearable="clearable"
        :multiple="multiple"
        :chips="chips"
        :deletable-chips="deletableChips"
        :cache-items="cacheItems"
        @input="$emit('input', $event)"
      />
    </div>
  </keep-alive>
</template>

<script>
// components
import contactPickerProps from '@/components/global_components/pickers/contact_picker/mixins/contact-picker-props';

export default {
  name: 'WorkContactPickerOnlyInputField',
  mixins: [contactPickerProps],
  computed: {
    component() {
      if (this.isFormElement) {
        return 'w-form-autocomplete-lazy';
      }
      return 'w-autocomplete-lazy';
    }
  }
};
</script>
